module.exports = "https://r.nearpod.com/assets/media/image/help_icon-eeceff61208e2b88f61a494a2765b934.svg";